module.exports = "<app-cabecera-formulario [dDatosCompartidosCabecera] = \"dDatosCompartidosCabecera\"></app-cabecera-formulario>\r\n<div class=\"container-cards\" style=\"background-color: #eeeeee;min-height: 400px;\">\r\n\t<app-formulario [dDatosCompartidosCabecera] = \"dDatosCompartidosCabecera\"></app-formulario>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.html
// module id = ../../../../../src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.html
// module chunks = main